import type { Components } from '@mui/material/styles';

export default function MuiIcon(): Components['MuiIcon'] {
  return {};
}
